var React = require('react');

function IcReviewComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-review"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M40.5996 33.0243H10.5443L7.39961 36.1006V7.82429H40.5996V33.0243ZM28.9415 27.6714L23.9996 24.6725L19.0577 27.6714L20.3662 22.0577L15.9752 18.2577L21.7612 17.7932L23.9996 12.4718L26.238 17.7932L32.024 18.2577L27.633 22.0577L28.9415 27.6714ZM11.7511 35.8243L4.59961 42.9758V8.42429C4.59961 7.48469 4.92716 6.69526 5.59887 6.02356C6.27058 5.35185 7.06 5.02429 7.99961 5.02429H39.9996C40.9392 5.02429 41.7286 5.35185 42.4003 6.02356C43.0721 6.69526 43.3996 7.48469 43.3996 8.42429V32.4243C43.3996 33.3639 43.0721 34.1533 42.4003 34.825C41.7286 35.4967 40.9392 35.8243 39.9996 35.8243H11.7511Z","fill":"white"})));
}

IcReviewComponent.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcReviewComponent;

IcReviewComponent.default = IcReviewComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackModalV2/images/ic-review.component.svg
// module id = 704
// module chunks = 0